import { UserSummary } from "../user-summary";
import { RequestBasePageIds } from "./request-base";
import { ResponseBasePage } from "./response-base";

export class RequestUserSummary extends RequestBasePageIds {

  companyId?: string | null;
  licenseId?: string | null;
  assignedToLicenseId?: string | null;
  roleId?: string | null;
  authId?: string | null;
  intAppCode?: string | null;
  activeUser?: boolean | null;
  activeLicenseUser?: boolean | null;
  startsWith?: string | null;
  hasEmail?: string | null;
  includeEmail?: boolean | null;
}

export class ResponseUserSummary extends ResponseBasePage<UserSummary> {

}

